import React from "react";

export default function CardSummary(props) {
  let filterdEvents = [];
  const renderEvents = function () {
    props.setRenderSearchCriteria(false);
    props.setFilteredEvents([]);
  };

  // Constants for CalcMinute Function
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;

  // Calculates total minutes of an event
  const calcTotalMinutes = function (start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    return Math.floor((endTime.getTime() - startTime.getTime()) / minute);
  };

  // Calculates total days of a multi/full day event
  const calcTotalDays = function (startDay, endDay) {
    return Math.floor((endDay.getTime() - startDay.getTime()) / day);
  };

  // Create Array with Organised event Data and push to State

  props.events.forEach((elemnent) => {
    const totalMinutesInit = calcTotalMinutes(
      elemnent.start.dateTime,
      elemnent.end.dateTime
    );
    const startDayInit = new Date(elemnent.start.date);
    const endDayInit = new Date(elemnent.end.date);
    const totalDaysInit = calcTotalDays(startDayInit, endDayInit);

    const curEvent = {
      title: elemnent.summary,
      day: new Date(
        elemnent.start.date ? elemnent.start.date : elemnent.start.dateTime
      ).toDateString(),
      startDay: startDayInit,
      endDay: endDayInit,
      startTime: elemnent.start.dateTime
        ? new Date(elemnent.start.dateTime).toTimeString().slice(0, 5)
        : "",
      endTime: elemnent.end.dateTime
        ? new Date(elemnent.end.dateTime).toTimeString().slice(0, 5)
        : "",
      totalMinutes: totalMinutesInit,
      minutes: totalMinutesInit % 60,
      hours: Math.floor(totalMinutesInit / 60),
      days: totalDaysInit,
    };
    filterdEvents.push(curEvent);
  });

  filterdEvents.forEach((e) => {
    if (isNaN(e.totalMinutes)) {
      e.totalMinutes = e.days * 24 * 60;
      e.hours = Math.floor(e.totalMinutes / 60);
      e.minutes = e.totalMinutes % 60;
    }
  });

  return (
    <div className="text-center">
      {filterdEvents < 1 ? (
        <div className="flex-col justify-center text-center m-4 p-6 bg-gray-200 rounded-lg">
          "No results match your search! Try again with different information."
          <button
            className="block mt-6 mx-auto bg-fifthDarkOrange text-white hover:border-fourthOrange font-semibold py-2 px-4 border border-fourthOrange  hover:border-transparent rounded text-sm hover:bg-fourthOrange"
            onClick={() => props.setRenderSearchCriteria(false)}
          >
            Try Again
          </button>
        </div>
      ) : (
        <div className="flex-col justify-center text-center m-4 p-6 bg-gray-200 rounded-lg">
          "Found {filterdEvents.length} results that match your search!"
          <button
            className="inline mt-6 mx-auto bg-fifthDarkOrange text-white hover:border-fourthOrange font-semibold py-2 px-4 border border-fourthOrange hover:border-transparent rounded text-sm hover:bg-fourthOrange mr-6"
            onClick={() => props.setFilteredEvents(filterdEvents)}
          >
            Show Results
          </button>
          <button
            className="inline mt-6 mx-auto bg-fifthDarkOrange text-white hover:border-fourthOrange font-semibold py-2 px-4 border border-fourthOrange hover:border-transparent rounded text-sm hover:bg-fourthOrange"
            onClick={() => renderEvents()}
          >
            New Search
          </button>
        </div>
      )}
    </div>
  );
}
